import * as React from "react"
import { Box, Button, NoSsr } from "@mui/material"
import { HiExclamationCircle, HiOutlineX } from "react-icons/hi"

import { useAuth } from "context/auth"
import { useClearQueryCache } from "hooks/useClearQueryCache"

export default function ImpersonationBanner() {
  const { isImpersonating, impersonation, setImpersonation } = useAuth()
  const { clearQueryCache } = useClearQueryCache()

  return (
    <NoSsr>
      {isImpersonating && (
        <Box
          role="banner"
          sx={{
            position: "fixed",
            bottom: { xs: 50, sm: 0 },
            margin: "8px auto",
            width: "max-content",
            display: "flex",
            alignItems: "center",
            flexDirection: { xs: "column", sm: "row" },
            justifyContent: "space-between",
            py: 0.5,
            px: 1.5,
            borderRadius: { xs: 1, sm: 99 },
            boxShadow: 2,
            color: "gray.100",
            backgroundColor: "red.500",
            zIndex: 9999,
            isolation: `isolate`,
            fontSize: "xs",
          }}
        >
          <>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 0.5,
                fontWeight: "semibold",
              }}
            >
              <HiExclamationCircle size={20} />{" "}
              <Box>
                You are impersonating{" "}
                <Box
                  component="span"
                  sx={{
                    fontWeight: "bold",
                  }}
                >
                  {impersonation?.email}
                </Box>{" "}
                <Box
                  component="span"
                  sx={{
                    display: { xs: "none", sm: "inline-flex" },
                  }}
                >
                  ({impersonation?.id})
                </Box>
              </Box>
            </Box>
            <Button
              // @ts-ignore
              variant="white"
              size="small"
              sx={{ fontSize: "xs", py: 0.5 }}
              endIcon={<HiOutlineX />}
              onClick={() => {
                setImpersonation(null)
                clearQueryCache()
              }}
            >
              Stop Impersonating
            </Button>
          </>
        </Box>
      )}
    </NoSsr>
  )
}
